import React from 'react';
import { TopHeroStyled } from './top-hero.styled';
import i18n from '../../../../../translations/strings';
import { titles } from './constants';

const TopHero = () => {
  return (
    <TopHeroStyled.Container container>
      <TopHeroStyled.LogoAndDescriptionContainer item md={4} xs={12}>
        <TopHeroStyled.Logo>{i18n.t('landing.landingText')}</TopHeroStyled.Logo>
        <TopHeroStyled.Description>
          {i18n.t('landing.topHeroDescription')}
        </TopHeroStyled.Description>
      </TopHeroStyled.LogoAndDescriptionContainer>
      <TopHeroStyled.TitlesContainer container item md={8} xs={12}>
        {titles.map((item: any, index: number) => (
          <TopHeroStyled.TitleContainer key={index} item md={3} xs={6}>
            <TopHeroStyled.svg>{item.svg}</TopHeroStyled.svg>
            <TopHeroStyled.Title>{item.name}</TopHeroStyled.Title>
          </TopHeroStyled.TitleContainer>
        ))}
      </TopHeroStyled.TitlesContainer>
    </TopHeroStyled.Container>
  );
};

export default TopHero;
